// src/Redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "./slicer/homeSlicer";
import aboutUsReducer from "./slicer/aboutUsSlicer";
import aluminaiReducer from "./slicer/aluminaiSlicer";
import researchAndStudentReducer from "./slicer/researchAndStudentSlice";
import itServicesReducer from "./slicer/itServicesSlice";
import contactUsReducer from "./slicer/contactUsSlice";
import galleryReducer from "./slicer/gallerySlice";
import academicReducer from "./slicer/academicSlice"
import departmentsReducer from "./slicer/departmentsSlice"
import degreeReducer from "./slicer/degreeSlice"
import CareersReducer from "./slicer/careersSlice"

const store = configureStore({
  reducer: {
    home: homeReducer,
    aboutUs: aboutUsReducer,
    aluminai: aluminaiReducer,
    research: researchAndStudentReducer,
    services: itServicesReducer,
    contact: contactUsReducer,
    gallery: galleryReducer,
    academic : academicReducer,
    departments : departmentsReducer,
    degree : degreeReducer,
    careers : CareersReducer
    // other reducers if any
  },
});

export default store;
